function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityAllinclusiveFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.018 10a6 6 0 11-3.636 10.771l-.007.01-2.766-2.212 1.598-1.284 2.088 1.67.012-.016a4 4 0 10.076-5.948l-.009-.01-.118.093L17.6 16l.006.006-1.597 1.283-.01-.008-4.197 3.357-.03.024-.148.119-.001-.002a6 6 0 11.24-9.368l2.528 2.021-1.598 1.284-2.104-1.683-.002.005c-.032-.03-.065-.057-.098-.085l-.19-.152a4 4 0 10.312 6.139l.003.006.909-.728.002.003.898-.722 1.874-1.5-.004-.003 1.597-1.283.009.007 4.375-3.5.006.007A5.974 5.974 0 0124.018 10z",
    fill: props.color
  }));
}

export default SvgIconFacilityAllinclusiveFilled;